import { FaqProps } from "src/components/organisms/FAQ"
import * as React from "react"
import * as styles from "src/components/organisms/FAQ/styles.module.scss"

export const MockFaqData: FaqProps = {
    items: [
        {
            title: "Liberica Native Image Kit",
            items: [
                {
                    questionTxt: "01. What does Liberica Native Image Kit do?",
                    children: (
                        <p className={styles.question_text}>
                            NIK compiles JVM-based applications into platform native executables with the ahead-of-time compiler.
                        </p>
                    ),
                },
                {
                    questionTxt:
                        "02. Why should I use the Liberica Native Image Kit?\n",
                    children: (
                        <p className={styles.question_text}>
                            Native images created with NIK have several advantages over JVM applications:
                            <ul className={styles.question_text_list}>
                                <li>Almost instant startup time;</li>
                                <li>Optimized resource consumption and smaller static footprint;</li>
                                <li>Does not require JVM for execution;</li>
                                <li>Compatibility with multiple programming languages, like Kotlin, Scala, Apache Groovy and others.</li>
                            </ul>
                        </p>
                    ),
                },
                {
                    questionTxt:
                        "03. What Java versions are supported by NIK?",
                    children: (
                        <p className={styles.question_text}>
                            Java LTS versions, Java 17, Java 21, and the current Java 25 are supported by Liberica NIK.
                        </p>
                    ),
                },
                {
                    questionTxt: "04. What configurations are supported by NIK?",
                    children: (
                        <p className={styles.question_text}>
                            NIK works on Windows, Linux (including Alpine), macOS installed on
                            machines with both x86, x64, and ARM CPUs (Linux only). You can use
                            both glibc and musl.
                        </p>
                    ),
                },
                {
                    questionTxt: "05. Does Liberica NIK work with containers?",
                    children: (
                        <p className={styles.question_text}>
                            Yes. There are a few ways to execute containerized applications
                            with Liberica NIK. It enhances such apps with less RAM consumption,
                            ease of communication, and high running speed.
                        </p>
                    ),
                },
                {
                    questionTxt: "06. What is a native image?",
                    children: (
                        <p className={styles.question_text}>
                            Native image is the executable binary file that contains your application,
                            all its dependencies, and runtime components, allowing you to run your
                            Java program on any supported configuration without the need for installing
                            runtime or any setup. Native image is the easiest way to distribute your
                            program and start it up faster.
                        </p>
                    ),
                },
            ],
        },
        {
            title: "GraalVM",
            items: [
                {
                    questionTxt: "01. What is GraalVM in NIK used for?",
                    children: (
                        <p className={styles.question_text}>
                            GraalVM is the open source virtual machine based on Java HotSpot VM,
                            and integrates an optimizing just-in-time (JIT) compiler, written in
                            Java. At run time, an application is loaded and executed normally by
                            the JVM. Liberica Native Image Kit adds these advantages to the native
                            image technology with an ahead-of-time compiler and Liberica JDK to
                            help with creating fastest and smallest native images.
                        </p>
                    ),
                },
                {
                    questionTxt: "02. Does GraalVM and NIK support JavaFX?",
                    children: (
                        <p className={styles.question_text}>
                            Yes, but only if you choose to utilize the NIK-full build of Liberica
                            Native Image Kit. The media and web functions of JavaFX are not fully
                            implemented. That means that native images created with Liberica JDK
                            will run JavaFX-based applications in case they don’t utilize media
                            and web functionality.
                        </p>
                    ),
                },,
                {
                    questionTxt: "03. How to fix the “error: invalid active developer path”?",
                    children: (
                        <>
                            <p className={styles.question_text}>
                                Remove the quarantine attribute from the bits. Run the following:
                            </p>
                            <p className={styles.question_text}>
                                <pre className="language-bash"><code className="language-bash"><span
                                    className="token function">sudo</span> xattr <span
                                    className="token parameter variable">-r</span> <span
                                    className="token parameter variable">-d</span> com.apple.quarantine /Library/Java/LibericaNativeImageKit</code></pre>
                            </p>
                        </>
                    ),
                },,
                {
                    questionTxt: "04. How to avoid GraalVM issues on macOS Catalina and later?",
                    children: (
                        <>
                            <p className={styles.question_text}>
                                If you get this error try running:
                            </p>
                            <p className={styles.question_text}>
                                <pre className="language-bash"><code
                                    className="language-bash">xcode-select <span
                                    className="token parameter variable">--install</span></code></pre>
                            </p>
                            <p className={styles.question_text}>
                                If it does not help try
                            </p>
                            <p className={styles.question_text}>
                                <code>
                                    <pre className="language-bash"><code className="language-bash"><span
                                        className="token function">sudo</span> xcode-select <span
                                        className="token parameter variable">--reset</span></code></pre></code>
                            </p>
                        </>
                    ),
                },
            ],
        }
    ],
}
